import clsx from 'clsx';
import type { Range } from '@/lib/admin-types';

export type RangePickerProps<T extends string = Range> = {
  value: T;
  onChange: (r: T) => void;
  options?: readonly T[];
};

const DEFAULT_OPTIONS: Range[] = ['7d', '30d', '90d'];

export function RangePicker<T extends string = Range>({
  value,
  onChange,
  options,
}: RangePickerProps<T>) {
  const choices = (options ?? DEFAULT_OPTIONS) as readonly T[];
  return (
    <div className="inline-flex rounded-xl border border-gray-200 bg-white p-0.5 shadow-sm">
      {choices.map((opt) => (
        <button
          key={opt}
          type="button"
          onClick={() => onChange(opt)}
          className={clsx(
            'rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
            value === opt
              ? 'bg-primary text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          )}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
